import { render } from "./deal-item.vue?vue&type=template&id=0ced8d9a"
import script from "./deal-item.vue?vue&type=script&lang=js"
export * from "./deal-item.vue?vue&type=script&lang=js"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__